<script lang="ts">
	let className = '';
	export { className as class };
	import { twMerge } from 'tailwind-merge';
</script>

<div
	class={twMerge(
		'flex h-10 w-10 items-center justify-center rounded-full bg-primary-400',
		className
	)}
>
	<div
		class="ml-1 h-0 w-0
    border-b-[8px] border-l-[13px]
    border-t-[8px] border-b-transparent
    border-l-black border-t-transparent"
	></div>
</div>
